const emailValidate={
    required: "Please enter valid email address.",
     validate: {
                matchPatern: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
                "Email address must be a valid address",
                }
    }

const passwordValidate={
    required: "Please enter your password.",
    minLength: {
        value: 8,
        message: 'Password must be at least 8 characters long.'
    },
    validate: {
        matchPatern: (value) => /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/.test(value) ||
        "Password must contain atleast one number.",
     }
     
}



const firstnameValidate={
    required: "First name is required.",
    minLength: {
        value: 2,
        message: 'Please enter valid name.'
    },
    pattern: {
        value:/^[A-Za-z]+/,
        message:"Name cannot be started from a number."
    }
}

const lastnameValidate={
    required: "Last name is required.",
    pattern: {
        value:/^[A-Za-z]+/,
        message:"Last name cannot be started from a number."
    }
}


export {emailValidate,passwordValidate,firstnameValidate,lastnameValidate}
